export const selectAllDrives = (state) => state.drive.drives;
export const selectDrivesStatus = (state) => state.drive.status;
export const selectDrivesError = (state) => state.drive.error;
export const fullDrivesList = (state) => state.drive.originalDrives;

export const selectedDriveName = (state) => state.drive.selectedDriveName;
export const selectedDriveVideoURL = (state) => state.drive.selectedDriveVideoURL;
export const selectedDriveId = (state) => state.drive.selectedDriveId;

export const deleteDriveLoading = (state) => state.drive.deleteDriveLoading;
export const deleteDriveError = (state) => state.drive.deleteDriveError;

export const driveVideoUrlLoading = (state) => state.drive.videoUrlLoading;
export const driveVideoUrl = (state) => state.drive.videoUrl;
export const driveVideoUrlError = (state) => state.drive.videoUrlError;

export const driveStorageUrl = (state) => state.drive.storageUrl;

export const statedrivesJson = (state) => state.drive.statedrivesJson;
export const statedrivesLoading = (state) => state.drive.statedrivesLoading;
export const statedrivesError = (state) => state.drive.statedrivesError;
